import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Notfound } from './app/pages/notfound/notfound';
import { AuthGuard } from './app/auth.guard';
import { SubscriptionLocked } from './app/pages/subscription-locked/subscription-locked';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./app/pages/dashboard/dashboard').then((m) => m.Dashboard),
        canActivate: [AuthGuard]
      },
      { path: 'pages', loadChildren: () => import('./app/pages/pages.routes').then((m) => m.default), canActivate: [AuthGuard] }
    ]
  },
  { path: 'notfound', component: Notfound },
  { path: 'privacy-policy', loadComponent: () => import('./app/pages/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicyComponent) },
  { path: 'subscription-locked', component: SubscriptionLocked, canActivate: [AuthGuard] },
  { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes').then((m) => m.default) },
  // Customer-facing kiosk display: paired device, no user session, no layout, no guard.
  { path: 'display', loadComponent: () => import('./app/pages/customer-display/customer-display').then((m) => m.CustomerDisplayComponent) },
  { path: '**', redirectTo: '/notfound' }
];
